import { createAction, props } from '@ngrx/store'
import { DtoWrapper } from './dto.state'

// getNewValueFromBackend will trigger a request to the backend, despite potentially locally existing data.
export const getDtoRequested = createAction(
  '[Entity-Adapter] Getting dto requested',
  props<{ dtoType: string; id: number; enforceBackendRequest?: boolean }>()
)
export const getDtoSucceeded = createAction('[Entity-Effect] Getting dto succeeded', props<{ dto: DtoWrapper }>())
export const getDtoFailed = createAction('[Entity-Effect] Getting dto failed', props<{ err: Error }>())
export const getDtoAlreadyInStore = createAction('[Entity-Effect] Getting dto not needed, dto is already in store')
export const upsertDTO = createAction('[MultiPage] Insert or update single DTO-object', props<{ dto: DtoWrapper }>())
export const setPendingState = createAction(
  '[Be&Store-service] setting pending state for entity',
  props<{ storeId: string; cancelPending?: boolean }>()
)
export const setPendingStateForExistingEntity = createAction(
  '[Be&Store-service] setting pending state for existing entity',
  props<{ dto: DtoWrapper }>()
)

export const upsertDTOs = createAction(
  '[MultiPage] Insert or update multiple DTO-objects',
  props<{ dtos: DtoWrapper[] }>()
)

// this would play nicely with a delete effect, but that would deviate from the other actions.
export const removeDTO = createAction(
  '[Stored-Entity-Service] Remove DTO-object from the store',
  props<{ id: string }>()
)

export const resetAllDTOs = createAction('[PageNav] Reset all stored DTO-objects')
